import { createI18n } from "vue-i18n";
import ptBR from "./pt-BR.json";
import enUS from "./en-US.json";
import esES from "./es-ES.json";

export const SUPPORTED_LOCALES = ["pt-BR", "en-US", "es-ES"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = "en-US";

type MessageSchema = typeof enUS;

export function resolveLocale(query: string | null): SupportedLocale {
  if (!query) return DEFAULT_LOCALE;
  return normalize(query) ?? DEFAULT_LOCALE;
}

function normalize(tag: string): SupportedLocale | null {
  const lowered = tag.toLowerCase();
  if (lowered.startsWith("pt")) return "pt-BR";
  if (lowered.startsWith("es")) return "es-ES";
  if (lowered.startsWith("en")) return "en-US";
  return null;
}

export const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    "pt-BR": ptBR,
    "en-US": enUS,
    "es-ES": esES,
  },
});
